import { memo } from 'react';

import { DropdownToggle } from './DropdownToggle';

export * from './DropdownToggle';

export default memo(DropdownToggle);
